import { fadeInit, fadeAnim } from './fade';
import { pictureInit, pictureAnim } from './picture';

export function cardInit(el) {
  const container = el instanceof HTMLElement ? el : el.node;
  const content = container.querySelector('.card__content');
  const picture = container.querySelector('.picture');

  fadeInit(content, 70);
  pictureInit(picture, 100);
}

export function cardAnim(el) {
  const container = el instanceof HTMLElement ? el : el.node;
  const content = container.querySelector('.card__content');
  const picture = container.querySelector('.picture');

  pictureAnim(picture, 200);
  fadeAnim(content, 400);
}
